import { graphql } from 'react-relay';

export const textBlockFragment = graphql`
    fragment TextBlock_contentBlock on TextBlock {
        title
        text
    }
`;
